import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  padding: 0 20px;
`;

export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

export const ContainerFlex = styled.div`
  flex: 1;
`;
